// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__ZLS+r","error":"Notification_error__tijZb","success":"Notification_success__7SWP1"};